import { render, staticRenderFns } from "./SnapshotChangeRequestSidebar.vue?vue&type=template&id=203eadd5"
import script from "./SnapshotChangeRequestSidebar.vue?vue&type=script&lang=js"
export * from "./SnapshotChangeRequestSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports